import React from 'react';

const renderCustomizedLabel: React.FC<{
  cx: any;
  cy: any;
  midAngle: any;
  innerRadius: any;
  outerRadius: any;
  percent: any;
  index: any;
}> = ({cx, cy, midAngle, innerRadius, outerRadius, percent}) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="#677489"
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
      style={{
        font: 'normal normal 600 16px/19px Montserrat'
      }}
    >
      {`${(percent * 100).toFixed(0) ?? 0}%`}
    </text>
  );
};

export default renderCustomizedLabel;
